import { RiskRating as RiskRatingEnum } from "~/graphql/supergraphEnums";
import { RiskRating } from "~/graphql/supergraphTypes";
import { cellVariants } from "./styles_vanilla.css";

export const getRiskRatingCellStyle = (riskRating: RiskRating | null | undefined): string => {
  if (riskRating === RiskRatingEnum.High || riskRating === RiskRatingEnum.Halt) {
    return cellVariants.danger;
  }
  return cellVariants.default;
};
